import { MarketplaceStatus } from "../../../api/marketplace";
import type { DateValue, MarketplaceInfo } from "../../../api/collection";

/**
 * A scheduled date is due once its midnight has passed, so anything dated today
 * or earlier is already picked up by the next run of the hourly publication
 * cron - showing the date there reads as "later", which is wrong.
 */
export const isScheduleDue = (date: DateValue, now: Date = new Date()) => {
  const scheduled = new Date(date.year, date.month - 1, date.day);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return scheduled.getTime() <= today.getTime();
};

export const PUBLISHING_WITHIN_THE_HOUR = "Publishing within 1 hour";

/** Label for a collection whose marketplace publication is scheduled. */
export const scheduledMarketplaceLabel = (date: DateValue) =>
  isScheduleDue(date)
    ? PUBLISHING_WITHIN_THE_HOUR
    : `Scheduled ${date.day}/${date.month}/${date.year}`;

/** True when the collection is scheduled and its date has already come due. */
export const hasDueSchedule = (marketplace?: MarketplaceInfo) =>
  !!marketplace?.date && isScheduleDue(marketplace.date);

/**
 * The publication cron selects on exactly this pair - pending with a date - so
 * a collection matching it is already owned by the cron. `pending` without a
 * date is a different thing: approved for the marketplace, waiting on someone
 * to decide when, and still publishable by hand.
 */
export const isAwaitingScheduledPublish = (marketplace?: MarketplaceInfo) =>
  marketplace?.status === MarketplaceStatus.Pending && !!marketplace.date;

/**
 * What the next cron run will actually publish. `marketplace.date` is never
 * cleared once a collection goes live, so the date alone keeps matching long
 * after the fact - the status is what separates the queue from its history.
 */
export const isDueForScheduledPublish = (marketplace?: MarketplaceInfo) =>
  isAwaitingScheduledPublish(marketplace) && hasDueSchedule(marketplace);
